import { render, staticRenderFns } from "./MA-SL-Disclosure.vue?vue&type=template&id=5b05ede1&scoped=true&"
import script from "./MA-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./MA-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./MA-SL-Disclosure.vue?vue&type=style&index=0&id=5b05ede1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05ede1",
  null
  
)

export default component.exports